import React from 'react';
import styled from 'styled-components/macro';
import { Droppable } from 'react-beautiful-dnd';

const DragAreaWrapper = styled.div`
  padding: 20px 40px;
`;

const DragAreaTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

const StyledDragArea = styled.div<{ isDraggingOver: boolean }>`
  width: 205px;
  margin-top: 20px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  height: 400px;
  overflow-y: auto;
  background-color: ${({ isDraggingOver, theme }) =>
    isDraggingOver ? theme.colorPalette.turquoise.light : theme.colorPalette.white};
`;

interface DragAreaProps {
  id: string;
  title: string;
  children: any;
}

const DragArea = (props: DragAreaProps) => (
  <DragAreaWrapper>
    <DragAreaTitle>{props.title}</DragAreaTitle>
    <Droppable droppableId={`${props.id}`}>
      {(provided, snapshot) => (
        <StyledDragArea isDraggingOver={snapshot.isDraggingOver} ref={provided.innerRef}>
          {props.children}
          {provided.placeholder}
        </StyledDragArea>
      )}
    </Droppable>
  </DragAreaWrapper>
);

export default DragArea;
